import { matchPath, useLocation } from 'react-router';

import { connectRoutes } from '../connectRoutes';
import { ConnectRoute } from '../types/ConnectRoute';

/**
 * Returns the current connect route.
 */
export const useCurrentRoute = (): ConnectRoute => {
  const location = useLocation();

  return matchRoute(connectRoutes(), location.pathname)!;
};

/**
 * Recursively find the route matching the pathname.
 */
const matchRoute = (
  routes: ConnectRoute[],
  pathname: string,
): ConnectRoute | undefined => {
  for (const route of routes) {
    if (route.path) {
      const match = matchPath(route.path, pathname);

      if (match) {
        return route;
      }

      if (route.children) {
        const matchedChild = matchRoute(route.children, pathname);

        if (matchedChild) {
          return matchedChild;
        }
      }
    }
  }

  return undefined;
};
